import { useContext } from 'react';
import { DeferredActionContext } from '../../contexts/deferred-action-context';

/** Returns the app's pending-action coordinator when installed. */
export const useDeferredAction = () => useContext(DeferredActionContext);
